export default __webpack_public_path__ + "static/media/icon-reglage.1066cbbf.svg";